import { ActionTypes, defaultCategoryState, defaultState, defaultPreferenceIds } from './constants';

export function userPreferencesReducer(state = defaultState, action) {
  const { type, payload, meta } = action;

  switch (type) {
    case ActionTypes.REQUEST:
      return {
        ...state,
        ...(meta.category
          ? {
              byCategory: {
                ...state.byCategory,
                [meta.category]: userCategoryPreferencesReducer(state.byCategory[meta.category], action)
              }
            }
          : { loading: true, error: null })
      };
    case ActionTypes.SUCCESS:
      const { byId, byCategory } = payload.reduce(
        (acc, preference) => {
          acc.byId[preference.preferenceId] = preference;
          if (acc.byCategory[preference.category]) {
            acc.byCategory[preference.category].push(preference);
          } else {
            acc.byCategory[preference.category] = [preference];
          }

          return acc;
        },
        { byId: {}, byCategory: {} }
      );

      return {
        ...state,
        byId: {
          ...state.byId,
          ...byId
        },
        ...(meta.category
          ? {
              byCategory: {
                ...state.byCategory,
                [meta.category]: userCategoryPreferencesReducer(state.byCategory[meta.category], action)
              }
            }
          : {
              byCategory: {
                ...state.byCategory,
                ...Object.entries(byCategory).reduce((acc, [category, preferences]) => {
                  acc[category] = userCategoryPreferencesReducer(state.byCategory[category], {
                    type,
                    payload: preferences,
                    meta: { category }
                  });

                  return acc;
                }, {})
              },
              loaded: true,
              loading: false
            })
      };
    case ActionTypes.FAILURE:
      return {
        ...state,
        ...(meta.category
          ? {
              byCategory: {
                ...state.byCategory,
                [meta.category]: userCategoryPreferencesReducer(state.byCategory[meta.category], action)
              }
            }
          : { loading: false, error: payload })
      };
    case ActionTypes.ADD:
      const addDefaultPreferenceId = state.byCategory[meta.category]?.defaultId;

      return {
        ...state,
        byId: {
          ...state.byId,
          [meta.preferenceId]: payload,
          ...(payload.default && addDefaultPreferenceId
            ? { [addDefaultPreferenceId]: { ...state.byId[addDefaultPreferenceId], default: false } }
            : {})
        },
        byCategory: meta.category
          ? {
              ...state.byCategory,
              [meta.category]: userCategoryPreferencesReducer(state.byCategory[meta.category], action)
            }
          : state.byCategory
      };
    case ActionTypes.UPDATE:
      const updateDefaultPreferenceId = state.byCategory[meta.category]?.defaultId;

      return {
        ...state,
        byId: {
          ...state.byId,
          [meta.preferenceId]: {
            ...state.byId[meta.preferenceId],
            ...payload
          },
          ...(payload.default && updateDefaultPreferenceId
            ? { [updateDefaultPreferenceId]: { ...state.byId[updateDefaultPreferenceId], default: false } }
            : {})
        },
        byCategory: meta.category
          ? {
              ...state.byCategory,
              [meta.category]: userCategoryPreferencesReducer(state.byCategory[meta.category], action)
            }
          : state.byCategory
      };
    case ActionTypes.REMOVE:
      return {
        ...state,
        byId: {
          ...state.byId,
          [meta.preferenceId]: undefined
        },
        byCategory: meta.category
          ? {
              ...state.byCategory,
              [meta.category]: userCategoryPreferencesReducer(state.byCategory[meta.category], action)
            }
          : state.byCategory
      };
    default:
      return state;
  }
}

export function userCategoryPreferencesReducer(state = defaultCategoryState, action) {
  const { type, payload, meta } = action;

  switch (type) {
    case ActionTypes.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case ActionTypes.SUCCESS:
      return {
        ...state,
        ids: payload.map((preference) => preference.preferenceId),
        defaultId: payload.find((preference) => preference.default)?.preferenceId ?? getDefaultPreferenceId(meta),
        loaded: true,
        loading: false
      };
    case ActionTypes.FAILURE:
      return {
        ...state,
        loading: false,
        error: payload
      };
    case ActionTypes.ADD:
      return {
        ...state,
        ids: [meta.preferenceId, ...state.ids],
        defaultId: payload.default ? meta.preferenceId : state.defaultId
      };
    case ActionTypes.UPDATE:
      return payload.default != null
        ? {
            ...state,
            defaultId: payload.default
              ? meta.preferenceId
              : meta.preferenceId === state.defaultId
              ? getDefaultPreferenceId(meta)
              : state.defaultId
          }
        : state;
    case ActionTypes.REMOVE:
      return {
        ...state,
        ids: state.ids.filter((id) => id !== meta.preferenceId),
        defaultId: payload.default ? getDefaultPreferenceId(meta) : state.defaultId
      };
    default:
      return state;
  }
}

function getDefaultPreferenceId(meta) {
  return defaultPreferenceIds[meta.category] ?? null;
}
